(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('payment'), require('credit-card-type'), require('styled-components')) :
	typeof define === 'function' && define.amd ? define(['react', 'payment', 'credit-card-type', 'styled-components'], factory) :
	(global.CreditCardInput = factory(global.React,global.payment,global.creditCardType,global.styled));
}(this, (function (React,payment,creditCardType,styled) { 'use strict';

var React__default = 'default' in React ? React['default'] : React;
payment = payment && payment.hasOwnProperty('default') ? payment['default'] : payment;
creditCardType = creditCardType && creditCardType.hasOwnProperty('default') ? creditCardType['default'] : creditCardType;
styled = styled && styled.hasOwnProperty('default') ? styled['default'] : styled;

var images = {
  placeholder: 'data:image/svg+xml;base64,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',
  visa: 'data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0idmlzYSI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRjZGOUZDIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iI0Y5OUYxQiIgZD0iTTAgMTZ2LjYzQTIuNCAyLjQgMCAwIDAgMi40MiAxOWgyNC4xNkEyLjQgMi40IDAgMCAwIDI5IDE2LjYyVjE2SDB6Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMyRDQ5OTAiIGQ9Ik0wIDN2LS42M0EyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzhWM0gwem0xMy45IDMuMTJsLTEuNDggNi43N2gtMS43N2wxLjQ2LTYuNzdoMS43OHptNy40NyA0LjM4bC45NC0yLjU1LjU0IDIuNTVoLTEuNDh6bTEuOTkgMi40SDI1bC0xLjQ0LTYuNzhoLTEuNTFhLjguOCAwIDAgMC0uNzYuNWwtMi42NyA2LjI3aDEuODdsLjM3LTFoMi4yOGwuMjIgMXptLTQuNjQtMi4yMmMwLTEuNzgtMi41MS0xLjg4LTIuNS0yLjY4LjAxLS4yNC4yNS0uNS43Ni0uNTdhMy40IDMuNCAwIDAgMSAxLjc1LjNsLjMxLTEuNDNjLS40Mi0uMTUtLjk3LS4zLTEuNjYtLjMtMS43NiAwLTMgLjkyLTMgMi4yNC0uMDEuOTcuODggMS41MiAxLjU1IDEuODQuNy4zMy45My41NS45My44NC0uMDEuNDYtLjU2LjY2LTEuMDcuNjYtLjkuMDItMS40MS0uMjMtMS44Mi0uNDJsLS4zMyAxLjQ4Yy40Mi4xOSAxLjE5LjM1IDEuOTguMzYgMS44NyAwIDMuMDktLjkgMy4xLTIuMzJ6bS03LjM3LTQuNTZMOC40NyAxMi45SDYuNkw1LjE4IDcuNWMtLjA5LS4zMy0uMTctLjQ1LS40My0uNkE3LjUzIDcuNTMgMCAwIDAgMyA2LjMzbC4wNC0uMmgzLjAzYy4zOCAwIC43My4yNi44Mi43bC43NSAzLjkxIDEuODUtNC42aDEuODZ6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+',
  mastercard: 'data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0ibWFzdGVyY2FyZCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjMDAzNjYzIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxjaXJjbGUgaWQ9InNoYXBlIiBjeD0iMTAuNSIgY3k9IjkuNSIgcj0iNi41IiBmaWxsPSIjRUIxQzI2Ii8+ICAgICAgICA8Y2lyY2xlIGlkPSJzaGFwZSIgY3g9IjE4LjUiIGN5PSI5LjUiIHI9IjYuNSIgZmlsbD0iI0Y5OUYxQiIvPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRUY1RDIwIiBkPSJNMTQuNSA0LjM4YTYuNDkgNi40OSAwIDAgMCAwIDEwLjI0IDYuNDkgNi40OSAwIDAgMCAwLTEwLjI0eiIvPiAgICAgIDwvZz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==',
  amex: 'data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0iYW1leCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIDIpIj4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iIzFEOTFDRSIgZD0iTTI3LjU4IDE5SDMuNDJBMi40IDIuNCAwIDAgMSAxIDE2LjYyVjIuMzhBMi40IDIuNCAwIDAgMSAzLjQyIDBoMjQuMTZBMi40IDIuNCAwIDAgMSAzMCAyLjM4djE0LjI1QTIuNCAyLjQgMCAwIDEgMjcuNTggMTl6Ii8+ICAgICAgICA8cG9seWxpbmUgaWQ9InNoYXBlIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjUuMDYzIDExLjg5NiA0LjU5MSAxMyAuMzYgMTMgMy42OTkgNiAxMS42NzQgNiAxMi40NzkgNy41NDYgMTMuMjMxIDYgMTYuMDY0IDYgMTcuNDkyIDYgMjMuOTgzIDYgMjQuOTAyIDYuOTYxIDI1Ljg4OSA2IDMwLjg4MiA2IDI3LjMzNyA5LjQ5MiAzMC43MjkgMTMgMjUuODk3IDEzIDI0LjgxNiAxMS45NjkgMjMuNzQ0IDEzIDE3LjQ5MiAxMyAxNi4wNjQgMTMgNi40OTYgMTMgNS45NzcgMTEuODk2Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMxRDkxQ0UiIGQ9Ik01Ljk4IDExLjk3aC0uOTIuOTJ6TTE2LjIgN2gtMi4xbC0xLjU4IDMuMzVMMTAuODIgN2gtMi4xdjQuODVMNi41NSA3SDQuNThsLTIuMzIgNWgxLjQybC40Ny0xLjE0aDIuN0w3LjM5IDEySDEwVjcuOTNMMTEuODUgMTJoMS4yMmwxLjg0LTR2NGgxLjI5Vjd6bTguNjcgMS42MkwyMy4zNyA3aC02LjAydjVIMjMuMTdsMS42NS0xLjY0TDI2LjQ4IDEyaDEuNTVsLTIuMzctMi41M0wyOC4xIDdoLTEuNjJsLTEuNjEgMS42MnpNMjEuNyAxMWgtMy4wNlY5LjloMy4wNlY4LjloLTMuMDZWOGgzLjA2di0uODVsMi4yNyAyLjI3LTIuMjcgMi4yOFYxMXpNNS41MyA3LjgybC44OCAyLjAzSDQuNThsLjk1LTIuMDN6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+'
};

var ERROR_TEXT__INVALID_EXPIRY_DATE = 'Expiry date is invalid';
var ERROR_TEXT__MONTH_OUT_OF_RANGE = 'Expiry month must be between 01 and 12';
var ERROR_TEXT__YEAR_OUT_OF_RANGE = 'Expiry year cannot be in the past';

var EXPIRY_DATE_REGEX = /^(\d{2})\/(\d{4}|\d{2})$/;
var MONTH_REGEX = /(0[1-9]|1[0-2])/;

var isExpiryInvalid = (function (expiryDate) {
  var splitDate = expiryDate.split('/');
  if (!EXPIRY_DATE_REGEX.test(expiryDate)) {
    return ERROR_TEXT__INVALID_EXPIRY_DATE;
  }

  var expiryMonth = splitDate[0];
  if (!MONTH_REGEX.test(expiryMonth)) {
    return ERROR_TEXT__MONTH_OUT_OF_RANGE;
  }

  var expiryYear = splitDate[1];
  var currentYear = new Date().getFullYear();
  currentYear = parseInt(expiryYear.length === 4 ? currentYear : currentYear.toString().substr(-2), 10);
  if (currentYear > parseInt(expiryYear, 10)) {
    return ERROR_TEXT__YEAR_OUT_OF_RANGE;
  }

  return false;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};









var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  display: inline-block;\n  ', ';\n'], ['\n  display: inline-block;\n  ', ';\n']);
var _templateObject2 = taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  background-color: white;\n  padding: 10px;\n  border-radius: 3px;\n  ', ';\n\n  &.is-invalid {\n    border: 1px solid #ff3860;\n    ', ';\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  position: relative;\n  background-color: white;\n  padding: 10px;\n  border-radius: 3px;\n  ', ';\n\n  &.is-invalid {\n    border: 1px solid #ff3860;\n    ', ';\n  }\n']);
var _templateObject3 = taggedTemplateLiteral(['\n  height: 1em;\n  ', ';\n'], ['\n  height: 1em;\n  ', ';\n']);
var _templateObject4 = taggedTemplateLiteral(['\n  position: relative;\n  margin-left: 0.5em;\n  display: flex;\n  align-items: center;\n\n  &::after {\n    content: attr(data-max);\n    visibility: hidden;\n    height: 0;\n  }\n\n  & .credit-card-input {\n    border: 0px;\n    position: absolute;\n    width: 100%;\n    font-size: 1em;\n    ', ';\n\n    &:focus {\n      outline: 0px;\n    }\n  }\n'], ['\n  position: relative;\n  margin-left: 0.5em;\n  display: flex;\n  align-items: center;\n\n  &::after {\n    content: attr(data-max);\n    visibility: hidden;\n    height: 0;\n  }\n\n  & .credit-card-input {\n    border: 0px;\n    position: absolute;\n    width: 100%;\n    font-size: 1em;\n    ', ';\n\n    &:focus {\n      outline: 0px;\n    }\n  }\n']);
var _templateObject5 = taggedTemplateLiteral(['\n  font-size: 0.8rem;\n  margin: 5px 0 0 0;\n  color: #ff3860;\n  ', ';\n'], ['\n  font-size: 0.8rem;\n  margin: 5px 0 0 0;\n  color: #ff3860;\n  ', ';\n']);

var Container = styled.div(_templateObject, function (_ref) {
  var styled$$1 = _ref.styled;
  return _extends({}, styled$$1);
});
var FieldWrapper = styled.div(_templateObject2, function (_ref2) {
  var styled$$1 = _ref2.styled;
  return _extends({}, styled$$1);
}, function (_ref3) {
  var invalidStyled = _ref3.invalidStyled;
  return _extends({}, invalidStyled);
});
var CardImage = styled.img(_templateObject3, function (_ref4) {
  var styled$$1 = _ref4.styled;
  return _extends({}, styled$$1);
});
var InputWrapper = styled.label(_templateObject4, function (_ref5) {
  var inputStyled = _ref5.inputStyled;
  return _extends({}, inputStyled);
});
var DangerText = styled.p(_templateObject5, function (_ref6) {
  var styled$$1 = _ref6.styled;
  return _extends({}, styled$$1);
});

var BACKSPACE_KEY_CODE = 8;
var CARD_TYPES = {
  mastercard: 'MASTERCARD',
  visa: 'VISA',
  amex: 'AMERICAN_EXPRESS'
};

var CreditCardInput = function (_Component) {
  inherits(CreditCardInput, _Component);

  function CreditCardInput(props) {
    classCallCheck(this, CreditCardInput);

    var _this = possibleConstructorReturn(this, (CreditCardInput.__proto__ || Object.getPrototypeOf(CreditCardInput)).call(this, props));

    _this.componentDidMount = function () {
      var cardNumber = _this.state.cardNumber;

      var cardType = payment.fns.cardType(cardNumber);
      _this.setState({
        cardImage: images[cardType] || images.placeholder
      });
    };

    _this.handleCardNumberBlur = function (e) {
      if (!payment.fns.validateCardNumber(e.target.value)) {
        _this.setFieldInvalid('Card number is invalid');
      }

      var cardNumberInputProps = _this.props.cardNumberInputProps;

      if (cardNumberInputProps.onBlur) {
        cardNumberInputProps.onBlur(e);
      }
    };

    _this.handleCardNumberChange = function (e) {
      var cardNumber = e.target.value;
      var cardNumberLength = cardNumber.split(' ').join('').length;
      var cardType = payment.fns.cardType(cardNumber);
      var cardTypeInfo = creditCardType.getTypeInfo(creditCardType.types[CARD_TYPES[cardType]]) || {};
      var cardTypeLengths = cardTypeInfo.lengths || [16];
      _this.setState({
        cardImage: images[cardType] || images.placeholder,
        cardNumber: cardNumber
      });

      payment.formatCardNumber(document.getElementById('card-number'));

      _this.setFieldValid();
      if (cardTypeLengths) {
        var lastCardTypeLength = cardTypeLengths[cardTypeLengths.length - 1];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = cardTypeLengths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var length = _step.value;

            if (length === cardNumberLength && payment.fns.validateCardNumber(cardNumber)) {
              if (_this.cardExpiryField.getRenderedComponent) {
                _this.cardExpiryField.getRenderedComponent().focus();
              } else {
                _this.cardExpiryField.focus();
              }
              break;
            }
            if (cardNumberLength === lastCardTypeLength) {
              _this.setFieldInvalid('Card number is invalid');
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var cardNumberInputProps = _this.props.cardNumberInputProps;

      if (cardNumberInputProps.onChange) {
        cardNumberInputProps.onChange(e);
      }
    };

    _this.handleCardExpiryBlur = function (e) {
      var cardExpiry = e.target.value.split(' / ').join('/');
      var expiryError = isExpiryInvalid(cardExpiry);
      if (expiryError) {
        _this.setFieldInvalid(expiryError);
      }

      var cardExpiryInputProps = _this.props.cardExpiryInputProps;

      if (cardExpiryInputProps.onBlur) {
        cardExpiryInputProps.onBlur(e);
      }
    };

    _this.handleCardExpiryChange = function (e) {
      var cardExpiry = e.target.value.split(' / ').join('/');
      payment.formatCardExpiry(document.getElementById('card-expiry'));

      _this.setFieldValid();

      var expiryError = isExpiryInvalid(cardExpiry);
      if (cardExpiry.length > 4) {
        if (expiryError) {
          _this.setFieldInvalid(expiryError);
        } else {
          if (_this.cvcField.getRenderedComponent) {
            _this.cvcField.getRenderedComponent().focus();
          } else {
            _this.cvcField.focus();
          }
        }
      }

      var cardExpiryInputProps = _this.props.cardExpiryInputProps;

      if (cardExpiryInputProps.onChange) {
        cardExpiryInputProps.onChange(e);
      }
    };

    _this.handleCVCBlur = function (e) {
      if (!payment.fns.validateCardCVC(e.target.value)) {
        _this.setFieldInvalid('CVC is invalid');
      }

      var cardCVCInputProps = _this.props.cardCVCInputProps;

      if (cardCVCInputProps.onBlur) {
        cardCVCInputProps.onBlur(e);
      }
    };

    _this.handleCVCChange = function (e) {
      var CVC = e.target.value;
      var CVCLength = CVC.length;
      payment.formatCardCVC(document.getElementById('cvc'));

      _this.setFieldValid();
      if (CVCLength >= 4) {
        var cardType = payment.fns.cardType(_this.state.cardNumber);
        if (!payment.fns.validateCardCVC(CVC, cardType)) {
          _this.setFieldInvalid('CVC is invalid');
        }
      }

      var cardCVCInputProps = _this.props.cardCVCInputProps;

      if (cardCVCInputProps.onChange) {
        cardCVCInputProps.onChange(e);
      }
    };

    _this.handleKeyDown = function (ref) {
      return function (e) {
        if (e.keyCode === BACKSPACE_KEY_CODE && !e.target.value) {
          if (ref.getRenderedComponent) {
            ref.getRenderedComponent().focus();
          } else {
            ref.focus();
          }
        }
      };
    };

    _this.setFieldInvalid = function (errorText) {
      var invalidClassName = _this.props.invalidClassName;
      // $FlowFixMe

      document.getElementById('field-wrapper').classList.add(invalidClassName);
      _this.setState({ errorText: errorText });
    };

    _this.setFieldValid = function () {
      var invalidClassName = _this.props.invalidClassName;
      // $FlowFixMe

      document.getElementById('field-wrapper').classList.remove(invalidClassName);
      _this.setState({ errorText: null });
    };

    _this.render = function () {
      var _this$state = _this.state,
          cardImage = _this$state.cardImage,
          errorText = _this$state.errorText;
      var _this$props = _this.props,
          cardExpiryInputProps = _this$props.cardExpiryInputProps,
          cardNumberInputProps = _this$props.cardNumberInputProps,
          cardCVCInputProps = _this$props.cardCVCInputProps,
          cardImageClassName = _this$props.cardImageClassName,
          cardImageStyle = _this$props.cardImageStyle,
          containerClassName = _this$props.containerClassName,
          containerStyle = _this$props.containerStyle,
          dangerTextClassName = _this$props.dangerTextClassName,
          dangerTextStyle = _this$props.dangerTextStyle,
          fieldClassName = _this$props.fieldClassName,
          fieldStyle = _this$props.fieldStyle,
          Input = _this$props.inputComponent,
          inputClassName = _this$props.inputClassName,
          inputStyle = _this$props.inputStyle,
          invalidStyle = _this$props.invalidStyle;

      return React__default.createElement(
        Container,
        { className: containerClassName, styled: containerStyle },
        React__default.createElement(
          FieldWrapper,
          {
            id: 'field-wrapper',
            className: fieldClassName,
            styled: fieldStyle,
            invalidStyled: invalidStyle
          },
          React__default.createElement(CardImage, {
            className: cardImageClassName,
            styled: cardImageStyle,
            src: cardImage
          }),
          React__default.createElement(
            InputWrapper,
            {
              inputStyled: inputStyle,
              'data-max': '9999 9999 9999 9999 9999'
            },
            React__default.createElement(Input, _extends({
              withRef: true,
              id: 'card-number',
              ref: function ref(cardNumberField) {
                _this.cardNumberField = cardNumberField;
              },
              autoComplete: 'cc-number',
              className: 'credit-card-input ' + inputClassName,
              pattern: '[0-9]*',
              placeholder: 'Card number',
              type: 'text',
              component: 'input'
            }, cardNumberInputProps, {
              onBlur: _this.handleCardNumberBlur,
              onChange: _this.handleCardNumberChange
            }))
          ),
          React__default.createElement(
            InputWrapper,
            { inputStyled: inputStyle, 'data-max': 'MM / YY 99' },
            React__default.createElement(Input, _extends({
              withRef: true,
              id: 'card-expiry',
              ref: function ref(cardExpiryField) {
                _this.cardExpiryField = cardExpiryField;
              },
              autoComplete: 'cc-exp',
              className: 'credit-card-input ' + inputClassName,
              pattern: '[0-9]*',
              placeholder: 'MM / YY',
              type: 'text',
              component: 'input'
            }, cardExpiryInputProps, {
              onBlur: _this.handleCardExpiryBlur,
              onChange: _this.handleCardExpiryChange,
              onKeyDown: _this.handleKeyDown(_this.cardNumberField)
            }))
          ),
          React__default.createElement(
            InputWrapper,
            { inputStyled: inputStyle, 'data-max': '999999' },
            React__default.createElement(Input, _extends({
              withRef: true,
              id: 'cvc',
              ref: function ref(cvcField) {
                _this.cvcField = cvcField;
              },
              autoComplete: 'cc-csc',
              className: 'credit-card-input ' + inputClassName,
              pattern: '[0-9]*',
              placeholder: 'CVC',
              type: 'text',
              component: 'input'
            }, cardCVCInputProps, {
              onBlur: _this.handleCVCBlur,
              onChange: _this.handleCVCChange,
              onKeyDown: _this.handleKeyDown(_this.cardExpiryField)
            }))
          )
        ),
        errorText && React__default.createElement(
          DangerText,
          { className: dangerTextClassName, styled: dangerTextStyle },
          errorText
        )
      );
    };

    _this.state = {
      cardImage: images.placeholder,
      cardNumberLength: 0,
      cardNumber: props.cardNumberInputProps.value,
      errorText: null
    };
    return _this;
  }

  return CreditCardInput;
}(React.Component);

CreditCardInput.defaultProps = {
  cardExpiryInputProps: {},
  cardNumberInputProps: {},
  cardCVCInputProps: {},
  cardImageClassName: '',
  cardImageStyle: {},
  containerClassName: '',
  containerStyle: {},
  dangerTextClassName: '',
  dangerTextStyle: {},
  fieldClassName: '',
  fieldStyle: {},
  inputComponent: 'input',
  inputClassName: '',
  inputStyle: {},
  invalidClassName: 'is-invalid',
  invalidStyle: {}
};

return CreditCardInput;

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-credit-card-input/lib/index.js
// module id = 518
// module chunks = 0